namespace GeniuzPOS.InventoryReport {
    export interface IcReport08DtRow {
        Id?: string;
        SkuCode?: string;
        WhsId?: string;
        WhsName?: string;
        WhsType?: number;
        ShopId?: string;
        ShopTypeId?: string;
        ShopGroupId?: string;
        ShopName?: string;
        SerailNo?: string;
        LotNo?: number;
        Status?: number;
        CreateBy?: string;
        CreateDate?: string;
    }

    export namespace IcReport08DtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'InventoryReport.IcReport08Dt';
        export const deletePermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const insertPermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const readPermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';
        export const updatePermission = '2Inventory:รายงาน:สินค้าคงเหลือ:View';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            WhsId = "WhsId",
            WhsName = "WhsName",
            WhsType = "WhsType",
            ShopId = "ShopId",
            ShopTypeId = "ShopTypeId",
            ShopGroupId = "ShopGroupId",
            ShopName = "ShopName",
            SerailNo = "SerailNo",
            LotNo = "LotNo",
            Status = "Status",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate"
        }
    }
}
